import { fetchUsers, unwrapThunk } from '@op/services'
import type { OPResolver } from '../common'

export const usersResolver = (async (store) => {
	await unwrapThunk(store.dispatch(fetchUsers()))
}) satisfies OPResolver
